import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { listenerMiddleware } from './middlewares'
import userReducer from './userSlice'
import uiReducer from './uiSlice'
import userRegReducer from './userRegistrationSlice'
import schoolReducer from './schoolSlice'
import schoolOnboardingReducer from './schoolOnboardingSlice'
import eccReducer from './eccSlice'
import eccOnboardingReducer from './eccOnboardingSlice'
import preRegistrationReducer from './preOnboardingSlice'
import schoolBookingsReducer from './schoolBookingsSlice'
import schoolModalReducer from './schoolModalSlice'
import calendarReducer from './calenderSlice'
import schoolReplacmentsReducer from './schoolReplacementsSlice'
import bookingReducer from './bookingSlice'
import schoolEventsReducer from './schoolEventsSlice'
import schoolEventReadsReducer from './schoolEventReadsSlice'
import orgReducer from './orgSlice'
import teacherReducer from './teacherSlice'
import {
    FLUSH,
    PAUSE,
    PERSIST,
    persistReducer,
    PURGE,
    REGISTER,
    REHYDRATE,
} from 'redux-persist'
import storageSession from 'redux-persist/lib/storage/session'
import { persistStore } from 'redux-persist'

// const middlewares: never[] = []
const rootReducer = combineReducers({
    calendar: calendarReducer,
    ecc: eccReducer,
    eccOnboarding: eccOnboardingReducer,
    user: userReducer,
    ui: uiReducer,
    userReg: userRegReducer,
    // schoolReg: schoolRegReducer,
    school: schoolReducer,
    schoolModal: schoolModalReducer,
    schoolOnboarding: schoolOnboardingReducer,

    schoolBookings: schoolBookingsReducer,
    schoolReplacements: schoolReplacmentsReducer,

    preRegistration: preRegistrationReducer,

    booking: bookingReducer,
    schoolEvents: schoolEventsReducer,
    schoolEventReads: schoolEventReadsReducer,

    org: orgReducer,
    teacher: teacherReducer,
})

const persistConfig = {
    key: 'root',
    storage: storageSession,
    whitelist: ['schoolOnboarding', 'eccOnboarding', 'org'],
    // whitelist: ['schoolOnboarding', 'eccOnboarding', 'preRegistration'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

let store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.REACT_APP_TARGET_ENV !== 'production',
    middleware: (gDm) =>
        gDm({
            serializableCheck: {
                ignoredActions: [
                    FLUSH,
                    REHYDRATE,
                    PAUSE,
                    PERSIST,
                    PURGE,
                    REGISTER,
                ],
            },
        }).concat(listenerMiddleware.middleware),
})
let persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>

export { store, persistor }
